<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>
        </v-content>
        <!-- Theme settings trigger — subtle icon in corner -->
        <v-btn
          small
          fab
          fixed
          bottom
          right
          class="settings-fab"
          @click="openThemeSettings"
          title="Theme Settings"
        >
          <v-icon small>tune</v-icon>
        </v-btn>
        <v-navigation-drawer
          class="setting-drawer"
          temporary
          right
          v-model="rightDrawer"
          hide-overlay
          fixed
        >
          <theme-settings></theme-settings>
        </v-navigation-drawer>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import ThemeSettings from "@/components/ThemeSettings";
import AppEvents from "./event";
export default {
  components: {
    AppDrawer,
    AppToolbar,
    ThemeSettings
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    }
  }),
  computed: {},
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },
  methods: {
    openThemeSettings() {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    }
  }
};
</script>

<style lang="stylus" scoped>
.page-wrapper
  min-height: calc(100vh - 64px - 50px - 81px)
  background: #f1f5f9

.settings-fab
  background: #ffffff !important
  border: 1px solid #e2e8f0 !important
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08) !important
  color: #64748b !important
  width: 40px !important
  height: 40px !important
  bottom: 24px !important
  right: 20px !important

  &:hover
    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.14) !important
    color: #1565C0 !important
</style>

<style lang="css">
.modern-data-table table thead tr {
  border-bottom: 1px solid #e2e8f0 !important;
}

.modern-data-table table thead th {
  border-bottom: 0 !important;
}

.modern-data-table table tbody tr:first-child,
.modern-data-table table tbody tr:first-child td {
  border-top: 0 !important;
}
</style>
